import React from 'react' // React must be in scope to use JSX

export const JLLServiceCategories = {
    "books": {
        id: "books",
        tags: 
        "book books illustration illustrations graphics cover covers art author illustrator publishing children's children novel young adult fiction fantasy character storybook story tales narrative worldbuilding storytelling"
    },
    "catalogues": {
        id: "catalogues",
        tags: 
            "editorial design brochures magazines catalogues catalogs"
    },
    "illustration": {
        id: "illustration",
        tags: "illustration art drawing draw drawings illustrations sketches sketching concept character artworks characters illustrator photoshop"
    },
    "design" : {
        id: "design",
        tags: "design graphic labels layout ui ux graphics layouts map maps product visual visualisation visualization indesign  acrobat adobe figma sketch"
    },
    "web" : {
        id: "web",
        tags: "websites user ux ui experience interaction responsive design interactive online internet socials media html css react code coding programming node wordpress elementor squarespace wix cpanel javascript js app application software mobile desktop email edms marketing mailchimp today klaviyo human centred WCAG accessibility AAA"
    },
    "events" : {
        id: "events",
        tags: "events parties party themed theme halloween corporate dinners social stationery settings namecards baby showers funerals birthdays anniversaries anniversary menus cocktails drinks carte"
    },
    "nuptial" : {
        id: "events",
        tags: "events weddings trivia nights hens dos stags buck's bucks hen's parties party themed theme halloween corporate dinners table numbers wishing wells baby showers bachelorette bachelor bridesmaids groomsmen funerals birthdays anniversaries anniversary menus cocktails drinks carte invitations invites seating charts plans placecards place settings namecards placenames"
    },
    "signage" : {
        id: "signage",
        tags: "signage posters pull-up banners outdoor pullup fabric  insert windows vinyl decals print gazebos marquees flags a-frames tents production large format sav self adhesive labels vinyl decals acylic  lightbox fabric frames triga walls stands booths"
    },
    "digital" : {
        id: "digital",
        tags: "presentations video audio production imaging reels after effects fx visual special editing premiere slides decks powerpoint blender"
    },
    "print" : {
        id: "print",
        tags: "print offset large gloss matte velvet format printer die press prepress production flyers posters signage signs cards a4 sra3 sra4 a5 a6 a7 a0 a2 a1 a3 stock paper weight gsm substrate media digital dieline router cutting cutline contour ink"
    },
    "stationery" : {
        id: "stationery",
        tags: "business cards foil scodix stationery"
    },
    "specialty-media" : {
        id: "specialty-media",
        tags: "print offset large format printer dye sublimation metal acrylic perspex press prepress production flyers posters substrate media dieline router cutting cutline contour ink heatpressed heat iron"
    },
    "decorative-finishing" : {
        id: "decorative-finishing",
        tags: "blind registered embossing debossing reliefs impression depression foil scodix matte varnish gloss laminate lamination dieline router cutting cutline contour ink heatpressed heat iron spot uv"
    },
    "games" : {
        id: "games",
        tags: "concept art characters environments storyboards creatures games boardgames fantasy science fiction orthogonal video games console desktop mobile pc cinematic film unity mudbox zbrush sculpture sculpting blender unreal engine card games"
    },
    "brand" : {
        id: "brand",
        tags: "logos brands development identity marketing style guides guidelines branding reputation reviews story culture"
    },
    "music" : {
        id: "music",
        tags: "music albums covers tracks songlists cds vinyls"
    },
    "offset" : {
        id: "offset",
        tags: "large volumes brochures magazines catalogues catalogs"
    },
    "textiles" : {
        id: "textiles",
        tags: "fabrics textiles digitising digitizing embroidery embroidered upholstery upholstered iron heatpressed"
    },
    "merch" : {
        id: "merch",
        tags: "shirts hoodies mugs cups stubbies holders mousepads jackets hats caps baseball bottles t-shirts tshirts custom"
    },
    "photography" : {
        id: "photography",
        tags: "photography photos images retouching contouring contours shots portraits landscapes studio"
    },
    "video" : {
        id: "video",
        tags: "videography editing premiere pro capcut sony vegas after fx effects"
    },
    "paint" : {
        id: "paint",
        tags: "watercolours acrylics paintings canvas gesso water-based artworks"
    },
    "vector" : {
        id: "vector",
        tags: "svgs scalable network graphics logos icons"
    }


}

export const JLLServiceList = [
    {
        id: "book-illustration",
        title: "Book Illustration",
        category: ["books", "illustration"],
        tags: []
    },
    {
        id: "editorial-design",
        title: "Editorial Design",
        category: ["books", "catalogues"],
        tags: []
    },
    {
        id: "graphic-design",
        title: "Graphic Design",
        category: ["design", "web", "print", "digital"],
        tags: []
    },
    {
        id: "wedding-event-stationery",
        title: "Wedding & Other Event Stationery",
        category: ["events", "design", "signage", "nuptial", "stationery"],
        tags: []
    },
    {
        id: "trivia-nights",
        title: "Trivia Nights",
        category: ["events", "design", "digital",  "stationery"],
        tags: []
    },
    {
        id: "marketing-collateral",
        title: "Marketing  Collateral",
        category: ["events", "design", "signage", "print",  "specialty-media"],
        tags: []
    },
    {
        id: "prepress",
        title: "Prepress",
        category: ["design", "signage", "print", "specialty-media"],
        tags: []
    },
    {
        id: "large-format-print",
        title: "Large Format Print",
        category: ["design", "signage", "print"],
        tags: []
    },
    {
        id: "offset-digital-print",
        title: "Offset & Digital Print Production",
        category: ["design", "signage", "print", "offset"],
        tags: []
    },
    {
        id: "digital-production",
        title: "Digital Production",
        category: ["design", "digital", "web"],
        tags: []
    },
    {
        id: "web-design",
        title: "Responsive Web Design",
        category: ["design", "digital", "web"],
        tags: []
    },
    {
        id: "concept-art",
        title: "Concept Art",
        category: ["illustration", "games"],
        tags: []
    },
    {
        id: "character-art",
        title: "Character Art",
        category: ["illustration", "games"],
        tags: []
    },
    {
        id: "boardgames",
        title: "Board / Card Game Art",
        category: ["illustration", "games"],
        tags: []
    },
    {
        id: "album-covers",
        title: "Album Covers",
        category: ["illustration", "music"],
        tags: []
    },
    {
        id: "ui-ux",
        title: "UI/UX Interaction Design",
        category: ["web", "design"],
        tags: []
    },
    {
        id: "brand-development",
        title: "Brand Development",
        category: ["brand", "design","vector"],
        tags: ""
    },
    {
        id: "vector",
        title: "Vector Art",
        category: ["brand", "design", "illustration","vector"],
        tags: ""
    },
    {
        id: "decorative",
        title: "Decorative Illustration",
        category: ["design", "illustration"],
        tags: []
    },
    {
        id: "raster",
        title: "Raster Illustration",
        category: ["illustration"],
        tags: []
    },
    {
        id: "product-launches",
        title: "Product Launches",
        category: ["events", "design", "marketing"],
        tags: []
    },
    {
        id: "community-action",
        title: "Community Action",
        category: ["events", "design", "print"],
        tags: []
    },
    {
        id: "hens-nights",
        title: "Hens Nights",
        category: ["events", "nuptial", "print", "stationery"],
        tags: []
    },
    {
        id: "stag-dos",
        title: "Stag Dos",
        category: ["events", "nuptial", "print", "stationery"],
        tags: []
    },
    {
        id: "baby-showers",
        title: "Baby Showers",
        category: ["events", "print"],
        tags: []
    },
    {
        id: "brochures",
        title: "Brochures",
        category: ["offset", "catalogues", "design"],
        tags: []
    },
    {
        id: "catalogues",
        title: "Catalogues",
        category: ["offset", "catalogues", "design"],
        tags: []
    },
    {
        id: "flyers",
        title: "Flyers",
        category: ["offset", "print", "design"],
        tags: []
    },
    {
        id: "router-cutting",
        title: "CNC Router Cutting",
        category: ["print", "design", "specialty-media", "decorative-finishing"],
        tags: []
    },
    {
        id: "foiling",
        title: "Foiling & SCODIX",
        category: ["decorative-finishing"],
        tags: "hot cold stamping"
    },
    {
        id: "embroidery",
        title: "Embroidery",
        category: ["textiles"],
        tags: []
    },
    {
        id: "embossing-debossing",
        title: "Embossing / Debossing",
        category: ["decorative-finishing", "print", "design"],
        tags: []
    },
    {
        id: "fabric-print",
        title: "Fabric Print",
        category: ["specialty-media", "print", "textiles"],
        tags: []
    },
    {
        id: "dye-sublimation",
        title: "Dye Sublimation",
        category: ["specialty-media", "print", "textiles"],
        tags: []
    },
    {
        id: "merch",
        title: "Corporate & Novelty Merch",
        category: ["brand", "print", "textiles", "events", "merch"],
        tags: []
    },
    {
        id: "sav-decals",
        title: "SAV Window / Wall Decals",
        category: ["print", "signage"],
        tags: []
    },
    {
        id: "car-decals",
        title: "Car Decals",
        category: ["print", "signage"],
        tags: []
    },
    {
        id: "decals",
        title: "Stickers / Labels",
        category: ["print", "signage", "specialty-media"],
        tags: []
    },
    {
        id: "acrylic-perspex",
        title: "Acrylic / Perspex",
        category: ["print", "signage", "specialty-media"],
        tags: []
    },
    {
        id: "flags",
        title: "Flags",
        category: ["print", "signage", "textiles"],
        tags: "feather teardrop ingot"
    },
    {
        id: "pullup-banners",
        title: "Pullup Banners",
        category: ["print", "signage"],
        tags: []
    },
    {
        id: "image-retouching",
        title: "Image Retouching",
        category: ["digital", "photography"],
        tags: "photoshop"
    },
    {
        id: "edms",
        title: "EDMs",
        category: ["web"],
        tags: []
    },
    {
        id: "social-media",
        title: "Socials",
        category: ["web", "video"],
        tags: []
    },
    {
        id: "video-editing",
        title: "Video Editing",
        category: ["digital", "video"],
        tags: []
    },
    {
        id: "business-cards",
        title: "Business Cards",
        category: ["stationery"],
        tags: []
    },
    {
        id: "wedding-invitations",
        title: "Wedding Invitations",
        category: ["stationery","nuptial"],
        tags: []
    },
    {
        id: "seating-chart",
        title: "Seating Charts",
        category: ["stationery","nuptial"],
        tags: []
    },
    {
        id: "place-cards",
        title: "Place Cards",
        category: ["stationery","nuptial"],
        tags: []
    },
    {
        id: "booklets",
        title: "Booklets",
        category: ["books","catalogues"],
        tags: []
    },
    {
        id: "painting-water-based",
        title: "Acrylic & Watercolour Paintings",
        category: ["paint","illustration"],
        tags: []
    },
    {
        id: "product-packaging",
        title: "Product Packaging",
        category: ["design"],
        tags: []
    },
    {
        id: "decorative-finishing",
        title: "Decorative Finishing",
        category: ["decorative-finishing"],
        tags: []
    },
    {
        id: "fabric-frames",
        title: "Fabric Frames",
        category: ["signage"],
        tags: "silicone edge"
    }

]